wbApp.controller('DeviceRegistrationCtrl', ['$scope', '$modal', '$translate', '$timeout', 'messageBoxSvc', 'rfidDeviceRegistrationSvc',
function ($scope, $modal, $translate, $timeout, messageBoxSvc, rfidDeviceRegistrationSvc) {

    $scope.gridSettings = {
        name: 'deviceRegistrations',
        keyExpr: 'id',
        columns: [
            { dataField: 'id', caption: $translate.instant('TXT_LBL_ID'), dataType: 'string', visible: false },
            { dataField: 'deviceSerialNumber', caption: $translate.instant('TXT_LBL_DEVICE_SERIAL_NUMBER'), dataType: 'string' },
            { dataField: 'isAllowed', caption: $translate.instant('TXT_LBL_ALLOWED'), dataType: 'boolean', width: '70px' },
            { dataField: 'createdAt', caption: $translate.instant('TXT_LBL_CREATED_AT'), dataType: 'date', format: { type: 'shortDateShortTime' }, width: '120px' },
            { dataField: 'updatedAt', caption: $translate.instant('TXT_LBL_UPDATED_AT'), dataType: 'date', format: { type: 'shortDateShortTime' }, width: '120px', sortOrder: 'desc' },
            { dataField: 'updatedByFullName', caption: $translate.instant('TXT_LBL_UPDATED_BY'), dataType: 'string', width: '180px' },
        ]
    }

    $scope.$on('refreshData', function (e, data) {
        refreshData();
    });

    function refreshData() {
        var selectedRowKeys = null;
        if (!!$scope.gridSettings && !!$scope.gridSettings.gridInstance) {
            selectedRowKeys = $scope.gridSettings.gridInstance.getSelectedRowKeys();
        }

        $scope.deviceRegistrations = rfidDeviceRegistrationSvc.getAllAsync();

        $scope.deviceRegistrations.$promise.then(function () {
            if (!!selectedRowKeys && !!$scope.gridSettings && !!$scope.gridSettings.gridInstance) {
                $timeout(function () {
                    $scope.gridSettings.gridInstance.selectRows(selectedRowKeys, false);
                }, 100);
            }
        });
    }

    refreshData();

    $scope.onRowEdit = function (data) {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.model = angular.copy(data);
            detailDialogPromise.$scope.onSave = function () {
                refreshData();
            };
            detailDialogPromise.show();
        });
    }

    var detailDialogPromise = $modal({
        templateUrl: 'rfid-cards/device-registration/device-registration-detail.html',
        show: false,
        scope: $scope.$new()
    });

}]);
